import React, { memo, useCallback } from "react";
import { useField } from "formik";
import { Typography } from "@mui/material";

import RpMuiSwitch from "@/components/muiCustom/switch/RpMuiSwitch";
import RRDDirectMailToolTips from "../RRDDirectMailToolTips";

function RRDDirectDistributionToggleInput({ name, storeCopyToggleName }) {
  const [distributionField, , distributionHelpers] = useField(name);
  const [, , storeCopyHelpers] = useField(storeCopyToggleName || "");

  const handleChange = useCallback(
    (e) => {
      const checked = e.target.checked;
      distributionHelpers.setValue(checked);
      if (!checked && storeCopyToggleName) {
        storeCopyHelpers.setValue(false);
      }
    },
    [storeCopyToggleName]
  );

  return (
    <>
      <Typography variant="body2" gutterBottom fontWeight={600}>
        Distribution <RRDDirectMailToolTips type="estimated_distribution" />
      </Typography>
      <RpMuiSwitch
        {...distributionField}
        checked={distributionField.value}
        onChange={handleChange}
      />
    </>
  );
}

export default memo(RRDDirectDistributionToggleInput);
